<template>
  <div class="nav-links public-nav-links">
    <a
      :href="whatsappEntryUrl"
      class="nav-link"
      target="_blank"
      rel="noopener noreferrer"
      title="Shop products and services on WhatsApp"
      @click="onNavigate"
    >
      <span class="nav-link__text nav-link__text--long">Shop Products &amp; Services</span>
      <span class="nav-link__text nav-link__text--short">Shop</span>
    </a>
    <a href="#sell-on-clinch" class="nav-link" title="Sell on Clinch" @click="onNavigate">
      <span class="nav-link__text nav-link__text--long">Sell on Clinch</span>
      <span class="nav-link__text nav-link__text--short">Sell</span>
    </a>
    <a href="#how-it-works" class="nav-link" title="How it works" @click="onNavigate">
      <span class="nav-link__text">How it works</span>
    </a>
    <a href="#trust-safety" class="nav-link" title="Trust and safety" @click="onNavigate">
      <span class="nav-link__text nav-link__text--long">Trust &amp; Safety</span>
      <span class="nav-link__text nav-link__text--short">Trust</span>
    </a>
    <a href="#pricing" class="nav-link" @click="onNavigate">
      <span class="nav-link__text">Pricing</span>
    </a>
    <router-link to="/login" class="nav-link" @click="onNavigate">
      <span class="nav-link__text">Login</span>
    </router-link>
    <a
      :href="whatsappEntryUrl"
      class="nav-link nav-link-cta nav-link-cta--green"
      target="_blank"
      rel="noopener noreferrer"
      title="Shop products and services on WhatsApp"
      @click="onNavigate"
    >
      <i class="fab fa-whatsapp" aria-hidden="true"></i>
      <span class="nav-link__text nav-link__text--long">Start shopping</span>
      <span class="nav-link__text nav-link__text--short">Shop</span>
    </a>
    <router-link to="/start" class="nav-link nav-link-cta" @click="onNavigate" title="Create My Shop">
      <span class="nav-link__text nav-link__text--long">Create My Shop</span>
      <span class="nav-link__text nav-link__text--short">Create shop</span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'PublicNavLinks',
  props: {
    whatsappEntryUrl: { type: String, required: true },
  },
  emits: ['navigate'],
  methods: {
    onNavigate() {
      this.$emit('navigate')
    }
  }
}
</script>

<style scoped>
.public-nav-links {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 0.125rem;
}

.public-nav-links .nav-link {
  position: relative;
  flex-shrink: 0;
  padding: 0.5rem 0.65rem;
  color: #475569;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.8125rem;
  line-height: 1.2;
  white-space: nowrap;
  border-radius: 8px;
  transition: color 0.15s ease, background 0.15s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-family: 'Nunito', 'Outfit', ui-sans-serif, system-ui, sans-serif;
}

.public-nav-links .nav-link__text--short {
  display: none;
}

.public-nav-links .nav-link:hover,
.public-nav-links .nav-link.router-link-active:not(.nav-link-cta) {
  color: var(--clinch-blue-primary, #33b5ff);
  background: rgba(51, 181, 255, 0.1);
}

.public-nav-links .nav-link-cta {
  margin-left: 0.35rem;
  background: linear-gradient(135deg, var(--clinch-blue-primary, #33b5ff) 0%, var(--clinch-blue-refresh-dark, #0081c9) 100%);
  color: #fff;
  padding: 0.5rem 0.95rem;
  border-radius: 999px;
  font-weight: 700;
  font-size: 0.8125rem;
  box-shadow: 0 6px 18px rgba(51, 181, 255, 0.28);
}

.public-nav-links .nav-link-cta:hover {
  color: #fff;
  background: linear-gradient(135deg, #4dc4ff 0%, var(--clinch-blue-refresh-dark, #0081c9) 100%);
  transform: translateY(-1px);
  box-shadow: 0 8px 22px rgba(51, 181, 255, 0.34);
}

.public-nav-links .nav-link-cta--green {
  background: linear-gradient(135deg, var(--clinch-green-primary, #00c853) 0%, #009e40 100%);
  box-shadow: 0 6px 18px rgba(0, 200, 83, 0.28);
}

.public-nav-links .nav-link-cta--green:hover {
  color: #fff;
  background: linear-gradient(135deg, #1bd36a 0%, #008c38 100%);
  box-shadow: 0 8px 22px rgba(0, 200, 83, 0.34);
}

.public-nav-links .nav-link-cta i {
  font-size: 1rem;
}

/* Medium desktop: shorter link labels */
@media (max-width: 1180px) {
  .public-nav-links .nav-link__text--long {
    display: none;
  }

  .public-nav-links .nav-link__text--short {
    display: inline;
  }
}

/* Mobile drawer — full labels, stacked */
@media (max-width: 1024px) {
  .public-nav-links {
    flex-direction: column;
    align-items: stretch;
    gap: 0.4rem;
    width: 100%;
  }

  .public-nav-links .nav-link__text--long {
    display: inline;
  }

  .public-nav-links .nav-link__text--short {
    display: none;
  }

  .public-nav-links .nav-link:not(.nav-link-cta) {
    color: #1e293b;
    background: transparent;
    border: 1px solid rgba(30, 41, 59, 0.1);
    white-space: normal;
  }

  .public-nav-links .nav-link:not(.nav-link-cta):hover {
    color: var(--clinch-blue-primary, #33b5ff);
    background: rgba(51, 181, 255, 0.08);
  }

  .public-nav-links .nav-link {
    width: 100%;
    padding: 0.85rem 1rem;
    font-size: 0.95rem;
    justify-content: flex-start;
  }

  .public-nav-links .nav-link-cta {
    margin-left: 0;
    margin-top: 0.35rem;
    justify-content: center;
    padding: 0.85rem 1rem;
    font-size: 0.95rem;
  }
}
</style>
